<template>
  <div class="newtaskPage editFroms" v-loading="loading">
    <div class="taskLeft">
      <steps :active="statusBar"></steps>
      <div class="setUp">
        <el-form label-width="85px" class="qcFrom" ref="newtaskPageFrom" :rules="rules" :model="previewFrom">
          <div v-if="steptype == 1">
            <common-title
              :name="'填写抽样任务条件'"
              :icon="'iconfont iconicon-condition'"
              :line-type="'1'"
            ></common-title>
            <el-row>
              <el-col :span="12" class="setUpcol">
                <el-row>
                  <el-form-item label="任务名称" prop="Name">
                    <el-input size="small" style="width:300px" v-model="previewFrom.Name"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="抽样类型" prop="Category">
                    <el-col>
                      <el-radio-group v-model="previewFrom.Category">
                        <el-radio
                          @change="getExportImg"
                          v-for="item in detailsRulesParameter.types"
                          :key="item.Value"
                          :label="item.Value"
                        >
                          {{ item.Text }}
                        </el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="设备类型" prop="ModalityTypes">
                    <el-checkbox-group v-model="previewFrom.ModalityTypes" @change="getExportImg">
                      <el-checkbox
                        v-for="item in detailsRulesParameter.modalityType"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="抽样主体" prop="samplingdoctor">
                    <el-col>
                      <el-radio-group v-model="previewFrom.samplingdoctor">
                        <el-radio :label="2" :value="2" :key="2" v-if="previewFrom.Category != 1 && !isUS">
                          审核医生
                        </el-radio>
                        <el-radio :label="3" :value="3" :key="3" v-if="previewFrom.Category == 1 && !isUS">
                          影像技师
                        </el-radio>
                        <el-radio :label="4" :value="4" :key="4" v-if="previewFrom.Category != 1 && !isUS">
                          诊断医生
                        </el-radio>
                        <el-radio :label="4" :value="4" :key="4" v-if="isUS">诊断医生</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="抽样时间" required>
                    <el-col>
                      <el-radio-group v-model="monthChoice" @change="monthChoiceChange">
                        <el-radio label="0">单月</el-radio>
                        <el-radio label="1">跨月</el-radio>
                      </el-radio-group>
                    </el-col>

                    <el-col class="sampletime" v-if="monthChoice == 0">
                      <el-form-item prop="StartDate">
                        <el-date-picker
                          class="time"
                          size="small"
                          v-model="previewFrom.StartDate"
                          type="month"
                          placeholder="选择月份"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <!-- 跨月 -->
                    <div v-if="monthChoice == 1">
                      <el-col class="sampletime">
                        <el-form-item prop="StartDate">
                          <el-date-picker
                            class="time"
                            size="small"
                            v-model="previewFrom.StartDate"
                            type="date"
                            placeholder="开始时间"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <span class="sampletime connect">-</span>
                      <el-col class="sampletime">
                        <el-form-item prop="EndDate" :rules="monthChoice != 0 ? rules.EndDate : [{ required: false }]">
                          <el-date-picker
                            class="time"
                            size="small"
                            v-model="previewFrom.EndDate"
                            type="date"
                            placeholder="结束时间"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </div>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="评分方案" prop="QCPlanGuid">
                    <el-select
                      @change="arrFilters"
                      style="width:296px"
                      size="small"
                      v-model="previewFrom.QCPlanGuid"
                      placeholder="请选择评分方案"
                    >
                      <el-option
                        v-for="item in listReport"
                        :key="item.QCPlanGuid"
                        :label="item.Name"
                        :value="item.QCPlanGuid"
                      >
                        {{ item.Name }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="评审人数" prop="Name">
                    <el-input size="small" style="width:296px" v-model.number="previewFrom.QCTimes" min="0"></el-input>
                    人/份
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="完成时间">
                    <el-date-picker
                      class="time"
                      size="small"
                      v-model="previewFrom.PlannedCompleteDt"
                      type="date"
                      placeholder="预计完成日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-row>

                <el-row>
                  <el-form-item label="医院等级" prop="hospitalGrade">
                    <el-select
                      size="small"
                      style="width:140px"
                      v-model="previewFrom.hospitalGrade"
                      placeholder="请选择医院等级"
                    >
                      <el-option v-for="item in hospitalGradeList" :key="item.id" :label="item.name" :value="item.id">
                        {{ item.name }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
              </el-col>
              <el-col :span="12" class="setUpcol" v-loading="rightLoading">
                <!-- <el-row>
									<el-form-item label="病例样本">
										<el-checkbox-group @change="arrFilters"
											v-model="detailsRulesParameter.IsPositives">
											<el-checkbox v-for="item in detailsRulesParameter.IsPositive"
												:key="item.value" :label="item.value">{{item.text}}</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</el-row> -->
                <el-row>
                  <el-form-item label="检查部位" prop="position">
                    <el-col>
                      <el-radio-group v-model="position" @change="positionChange">
                        <el-radio label="0">按大部位分类</el-radio>
                        <el-radio label="1">按具体部位分类</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row
                  v-if="position == 0 && detailsRulesParameter.BodyPart.length > 0"
                  class="paddingL"
                  style="margin-bottom:22px"
                >
                  <el-checkbox-group v-model="detailsRulesParameter.BodyParts" @change="checkType()">
                    <el-checkbox
                      v-for="item in detailsRulesParameter.BodyPart"
                      :key="item.Name"
                      :label="item.Name"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-row>
                <el-row v-else class="paddingL" style="margin-bottom:22px">
                  <el-tabs :value="activesName" stretch type="card" @tab-click="handleClick">
                    <el-tab-pane
                      v-for="(item, index) in detailsRulesParameter.BodyPart"
                      :key="item.Name"
                      :label="item.Name"
                      :name="item.Name"
                    >
                      <el-checkbox-group
                        v-if="item.Children.length > 0"
                        v-model="detailsRulesParameter.BodyParts"
                        @change="checkClick(detailsRulesParameter.BodyParts, item.BodyPart, index)"
                      >
                        <el-checkbox
                          v-for="items in item.Children"
                          :key="items.Id"
                          :label="items.Name"
                          @change="checkType($event, items)"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <div class="noDataAvailable" v-else>
                        <i class="iconfont iconicon-default-Nocontent"></i>
                        <div style="margin-top: 6px;">暂无内容</div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>

                  <div class="selectedItems" v-if="tabList.length > 0">
                    <div class="selectedItems-title">
                      已选检查项目
                      <div class="textRt" @click="positionChange()">
                        <i class="iconfont iconicon-clear" style="vertical-align: bottom;"></i>
                        清空
                      </div>
                    </div>
                    <div class="selectedItems-content">
                      <div class="contentList" v-for="item in tabList" :key="item.BodyPart">
                        <el-row>
                          <el-col :span="3">{{ item.BodyPart }}</el-col>
                          <el-col :span="21">
                            <el-tag
                              closable
                              v-for="(items, index) in item.ChildrenBodyPart"
                              :key="index"
                              @close="closeExperts(item.BodyPart, items)"
                              type="info"
                            >
                              {{ items.Name }}
                            </el-tag>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <el-form-item label="扫描类型" v-if="usHidden">
                    <el-select
                      style="width:296px"
                      size="small"
                      class="scanTypesClass"
                      filterable
                      multiple
                      v-model="detailsRulesParameter.ScanTypes"
                      placeholder="请选择扫描类型"
                    >
                      <el-option
                        v-for="item in detailsRulesParameter.ScanType"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                      >
                        {{ item.text }}
                      </el-option>
                    </el-select>
                    <!-- <el-checkbox-group v-model="detailsRulesParameter.ScanTypes">
											<el-checkbox v-for="item in detailsRulesParameter.ScanType" :key="item.text"
												:label="item.text" :value="item.text"></el-checkbox>
										</el-checkbox-group> -->
                  </el-form-item>
                </el-row>
                <el-row class="mart25">
                  <div>
                    <div class="settings">
                      抽样报告设置
                      <span>(条件选中时生效)</span>
                    </div>
                    <el-checkbox-group class="mart10" style="padding-left:85px" v-model="settings">
                      <el-checkbox label="WyxCheck">报告内容不满足20字不抽样</el-checkbox>
                      <br />
                      <el-checkbox label="DoctorCheck">个人月度审核不满20份不抽样</el-checkbox>
                      <br />
                      <!-- <el-checkbox label="无影像报告不抽样"></el-checkbox> -->
                    </el-checkbox-group>
                  </div>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item class="footerSetUp">
                <el-button type="primary" class="bigBtn" size="medium" @click="next(1)">下一步</el-button>
              </el-form-item>
            </el-row>
          </div>
          <div v-if="steptype == 2">
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item title="填写抽样任务条件" name="1" class="marb10">
                <template slot="title">
                  <div class="titleSelected">查看已选条件</div>
                </template>
                <div>
                  <detail-information
                    :previewFrom="previewFrom"
                    :detailsRulesParameter="detailsRulesParameter"
                  ></detail-information>
                </div>
              </el-collapse-item>
              <el-collapse-item title="不符合抽样中心" name="2" v-if="NotContailHospitals.length > 0">
                <template slot="title">
                  <div class="titleSelected">不符合抽样中心</div>
                </template>
                <div>
                  <el-table class="qcTable" :data="NotContailHospitals" max-height="300">
                    <el-table-column prop="HospitalName" label="中心名称"></el-table-column>
                    <el-table-column prop="ReportCount" label="总份数"></el-table-column>
                    <el-table-column prop="DoctorCount" label="医生总数"></el-table-column>
                    <el-table-column prop="" label="操作">
                      <template slot-scope="scope">
                        <span class="table-task-btn detail" @click="choiceClick(scope.row, scope.$index, 'notsamples')">
                          不可选医生{{ scope.row.NotSampledDCount }}位
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </el-collapse>
            <common-title :name="'选中心'" :icon="'iconfont iconicon-core-Notselected'" :line-type="'0'">
              <el-button type="primary" class="rt" size="mini" @click="modifyList">修改全局抽样与占比</el-button>
            </common-title>
            <div v-loading="selfLoading">
              <el-row>
                <el-table
                  ref="selectionTable"
                  class="qcTable"
                  v-if="Hospitals"
                  :data="Hospitals"
                  max-height="500"
                  @selection-change="handleSelectionChange"
                  @select="handleSelectionClick"
                  @select-all="handleselectAll"
                >
                  <el-table-column type="selection" width="80"></el-table-column>
                  <el-table-column width="140" prop="HospitalName" label="中心名称"></el-table-column>
                  <el-table-column prop="ReportCount" label="总份数"></el-table-column>
                  <el-table-column prop="samplingMethod" width="330" label="抽样方式 (每位医生)">
                    <template slot-scope="scope">
                      <el-radio
                        @change="radioFilters(scope.row, scope.row.Type, scope.$index)"
                        v-model="scope.row.Type"
                        v-for="item in detailsRulesParameter.TypeValue"
                        :key="item.value"
                        :label="item.value"
                      >
                        {{ item.text }}
                      </el-radio>
                      <input
                        class="ratioInput"
                        type="number"
                        @blur="getSampledNum(scope.row)"
                        v-model.number="scope.row.TypeValue"
                        min="0"
                      />
                      <span v-if="scope.row.Type == 1" class="ratioSpan">%</span>
                      <span v-if="scope.row.Type == 2" class="ratioSpan">例</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="samplingMethod" width="200" label="报告占比(阴性:阳性)">
                    <template slot-scope="scope" slot="header">
                      <el-tooltip class="item" effect="dark" content="总数为10,请填写0～10的整数" placement="bottom">
                        <span>
                          报告占比(阴性:阳性)
                          <i class="el-icon-info" style="color: #248AFD;"></i>
                        </span>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <div>
                        <input
                          class="ratioInput wid50"
                          type="number"
                          v-model.number="scope.row.Negative"
                          @blur="getSampledNum(scope.row, 'Negative')"
                          placeholder="阴性"
                          min="0"
                          max="10"
                        />
                        :
                        <input
                          class="ratioInput wid50"
                          type="number"
                          v-model.number="scope.row.Positive"
                          @blur="getSampledNum(scope.row, 'Positive')"
                          placeholder="阳性"
                          min="0"
                          max="10"
                        />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sampled" label="已选 (位)"></el-table-column>
                  <el-table-column prop="notSampled" label="未选 (位)"></el-table-column>
                  <el-table-column prop="SamplingCount" label="预抽报告 (份)" width="110"></el-table-column>
                  <el-table-column prop="NegtativeCount" label="阴性"></el-table-column>
                  <el-table-column prop="PositiveCount" label="阳性"></el-table-column>
                  <el-table-column prop="DoctorCount" label="医生总数"></el-table-column>
                  <el-table-column prop="SampledDoctorCount" label="可选医生" width="110">
                    <template slot-scope="scope">
                      <span class="table-task-btn detail" @click="choiceClick(scope.row, scope.$index)">
                        可选医生{{ scope.row.SampledDoctorCount }}位
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="SampledDoctorCount" label="不可选医生" width="120">
                    <template slot-scope="scope">
                      <span class="table-task-btn detail" @click="choiceClick(scope.row, scope.$index, 'notsamples')">
                        不可选医生{{ scope.row.NotSampledDCount }}位
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row class="footerBtn">
                <el-form-item class="footerSetUp marb0">
                  <el-button type="primary" class="toBack bigBtn" @click="toback(1)">上一步</el-button>
                  <el-button type="primary" class="bigBtn" @click="next(2)">下一步</el-button>
                </el-form-item>
              </el-row>
            </div>
          </div>
          <div v-if="steptype == 3">
            <common-title
              :name="'预览抽样任务条件'"
              :icon="'iconfont iconicon-condition'"
              :line-type="'0'"
            ></common-title>
            <detail-information
              :previewFrom="previewFrom"
              :detailsRulesParameter="detailsRulesParameter"
            ></detail-information>
            <common-title :name="'预览抽样医院'" :icon="'iconfont iconicon-preview'" :line-type="'0'"></common-title>
            <el-row class="table scrollbar exportFrom dialogFrom">
              <el-table
                ref="reportTable"
                class="qcTable"
                :data="HospitalsChoice"
                show-summary
                max-height="350"
                key="10"
              >
                <el-table-column width="140" prop="HospitalName" label="中心名称"></el-table-column>
                <el-table-column prop="ReportCount" label="总份数"></el-table-column>
                <el-table-column prop="" label="抽样方式 (每位医生)">
                  <template slot-scope="scope">
                    {{ scope.row.type | transforType }} {{ scope.row.TypeValue }}
                    <span v-if="scope.row.type == 1">%</span>
                    <span v-else>例</span>
                  </template>
                </el-table-column>
                <el-table-column prop="SamplingCount" label="抽样报告 (份)" width="110"></el-table-column>
                <el-table-column prop="samplingMethod" label="报告占比(阴性:阳性)">
                  <template slot-scope="scope">
                    <div class="center">{{ scope.row.Negative }}:{{ scope.row.Positive }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="NegtativeCount" label="阴性"></el-table-column>
                <el-table-column prop="PositiveCount" label="阳性"></el-table-column>
                <el-table-column prop="sampled" label="已抽样医生" width="180">
                  <template slot-scope="scope">
                    <span class="table-task-btn detail" @click="sampledClick(scope.row, 1)">
                      已抽样医生{{ scope.row.sampled }}位
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="notSampled" label="未抽样医生" width="180">
                  <template slot-scope="scope">
                    <span class="table-task-btn detail" @click="sampledClick(scope.row, 2)">
                      未抽样医生{{ scope.row.notSampled }}位
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-row class="footerBtn">
              <el-form-item class="footerSetUp">
                <el-button type="primary" class="toBack bigBtn" @click="toback(2)">上一步</el-button>
                <el-button type="primary" class="bigBtn" @click="onSubmit()">确 定</el-button>
              </el-form-item>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      :title="doctorDiaTitle"
      :visible.sync="dialogVisible"
      width="80%"
      class="scrollbar exportFrom dialogFrom"
    >
      <div class="dialogTitle" v-if="doctorDiaType">请选择{{ HospitalName }}的抽样医生</div>
      <el-table
        class="qcTable scrollbar"
        v-if="getDoctorslist"
        :data="getDoctorslist"
        ref="multipleTable"
        max-height="450"
        :key="doctorDiaTitle"
        @selection-change="dialogChange"
        @select="selectClick"
        @select-all="selectAll"
        v-loading="dialogLoading"
      >
        <el-table-column type="selection" width="80" v-if="doctorDiaType"></el-table-column>
        <el-table-column prop="DoctorName" label="医生姓名"></el-table-column>
        <el-table-column prop="TotalNum" label="总份数"></el-table-column>
        <el-table-column
          v-if="getDoctorslist && previewFrom.ModalityTypes && doctorDiaType"
          v-for="(item, index) in previewFrom.ModalityTypes"
          :key="index"
          :label="item"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.ModalityType[index].Count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SampledNum" v-if="sampledClicktype !== 2" label="抽样份数"></el-table-column>
        <el-table-column prop="NegtativeCount" label="阴性"></el-table-column>
        <el-table-column prop="PositiveCount" label="阳性"></el-table-column>
        <el-table-column prop="" label="备注" width="150" v-if="doctorDiaTitle != '已抽样医生'">
          <template slot-scope="scope">
            <input
              class="ratioInput dialogInput"
              v-if="scope.row.NoteType && doctorDiaType"
              type="text"
              v-model="scope.row.Note"
              placeholder="请输入备注"
            />
            <span v-if="!doctorDiaType">{{ scope.row.Note }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-footer mart10" align="center">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="distributionDoctor" v-if="doctorDiaType">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改中心列表" :visible.sync="modifydialog" width="50%" class="scrollbar exportFrom dialogFrom">
      <el-form label-width="140px" class="qcFrom" :rules="rules" :model="modifyFrom">
        <el-row>
          <el-form-item label="抽样方式(每位医生)" prop="Type">
            <el-col :span="14">
              <el-radio
                v-model="modifyFrom.Type"
                class="marr10"
                v-for="item in detailsRulesParameter.TypeValue"
                :key="item.value"
                :label="item.value"
              >
                {{ item.text }}
              </el-radio>
              <input class="ratioInput" type="number" v-model.number="modifyFrom.TypeValue" min="0" />
              <span v-if="modifyFrom.Type == 1" class="ratioSpan white">%</span>
              <span v-if="modifyFrom.Type == 2" class="ratioSpan white">例</span>
            </el-col>
            <el-col :span="10">
              <el-button type="primary" size="mini" @click="modifydetermine(1)">确定</el-button>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="报告占比(阴性:阳性)" prop="">
            <el-col :span="14" class="white">
              <input
                class="ratioInput wid50"
                type="number"
                v-model.number="modifyFrom.NegativePercent"
                @blur="changeNegative('Negative')"
                placeholder="阴性"
                min="0"
                max="10"
              />
              :
              <input
                class="ratioInput wid50"
                type="number"
                v-model.number="modifyFrom.PositivePercent"
                @blur="changeNegative('Positive')"
                placeholder="阳性"
                min="0"
                max="10"
              />
            </el-col>
            <el-col :span="10">
              <el-button type="primary" size="mini" @click="modifydetermine(2)">确定</el-button>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Api from "../../api";
import axios from "@/js/api";
import date from "@/js/date.js";
import steps from "../tool/steps.vue";
import detailInformation from "./detailInformation.vue";
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  components: {
    steps,
    detailInformation,
  },
  data() {
    return {
      settings: ["WyxCheck", "DoctorCheck"],
      isUS: false,
      activeNames: ["0"],
      NotContail: ["0"],
      statusBar: [
        {
          Text: "填写条件",
          Date: null,
          icon: "iconfont iconicon-condition",
          date: 1,
        },
        {
          Text: "选择中心",
          Date: null,
          icon: "iconfont iconicon-core-Notselected",
          date: null,
        },
        {
          Text: "查看预览",
          Date: null,
          icon: "iconfont iconicon-preview",
          date: null,
        },
        {
          Text: "创建成功",
          Date: null,
          icon: "iconfont iconicon-complete",
          date: null,
        },
      ],
      steptype: 1,
      setDate: "",
      previewFromRigth: {
        Category: [
          {
            Text: "",
          },
        ],
        IsPositive: [],
        Type: [
          {
            text: "",
          },
        ],
        ExpertGroupIDList: [
          {
            Name: "",
          },
        ],
        QCPlanGuid: [
          {
            Name: "",
          },
        ],
      },
      rules: {
        Name: [
          {
            required: true,
            message: "请输入质控任务名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256 个字符",
            trigger: "blur",
          },
        ],
        ModalityTypes: [
          {
            type: "array",
            required: true,
            message: "请至少选择一种设备",
            trigger: "change",
          },
        ],
        StartDate: [
          {
            required: true,
            message: "请选择开始日期",
            trigger: "change",
          },
        ],
        EndDate: [
          {
            required: true,
            message: "请选择结束日期",
            trigger: "change",
          },
        ],
        Category: [
          {
            required: true,
            message: "请选择抽样类型",
            trigger: "change",
          },
        ],
        QCPlanGuid: [
          {
            required: true,
            message: "请选择评分方案",
            trigger: "change",
          },
        ],
        QCTimes: [
          {
            required: true,
            message: "请输入评审次数",
            trigger: "blur",
          },
        ],
        samplingdoctor: [
          {
            required: true,
            message: "请选择抽样主体",
            trigger: "change",
          },
        ],
      },
      usHidden: true,
      dialogVisible: false,
      sampleReportForm: {
        ModalityTypes: "",
        ScanTypes: "",
        StartDt: "",
        EndDt: "",
        Postive: "",
        BodyParts: "",
        HospitalLevel: 0,
        Name: "",
        Category: 0,
        QCPlanGuid: "",
        PlannedCompleteDt: "",
        QCTimes: 0,
        Type: 0,
        TypeValue: 0,
        HospitalGuid: "",
        Doctors: [],
        NegativePercent: 0,
        PositivePercent: 0,
      },
      Hospitals: [],
      NotContailHospitals: [],
      HospitalsChoice: [],
      selfLoading: false,
      getDoctorslist: [],
      dialogLoading: false,
      HospitalName: "",
      dialogIndex: 0,
      dialogChoice: [],
      doctorDiaType: true,
      doctorDiaTitle: "选择医生",
      sampledClicktype: 0,
      position: "0",
      bodyPartDetail: [],
      activesName: "",
      tabList: [],
      checkboxType: true,
      newname: "",
      monthChoice: "0",
      modifydialog: false,
      modifyFrom: {
        Type: 2,
        TypeValue: 0,
        NegativePercent: 0,
        PositivePercent: 0,
      },
      scanTypeByBody: {
        modalityId: "",
        bodyPartId: "",
      },
    };
  },
  filters: {
    transforType: function(type) {
      let newType = type == 1 ? "按比例" : "按照固定值";
      return newType;
    },
  },
  computed: {
    ...Vuex.mapState("newtask", [
      "previewFrom",
      "AICompanys",
      "DiseaseTypes",
      "HospitalsSelset",
      "ExpertGroupList",
      "listReport",
      "previewData",
      "detailsRulesParameter",
      "rightLoading",
    ]),
    ...Vuex.mapState("managerPlanList", ["statusList", "taskListTitle", "SamplingTaskGuId", "reviewName", "loading"]),
    ...Vuex.mapState("breadcrumb", ["collapseflag", "expertflag", "breadListState", "hospitalGradeList"]),
  },
  activated() {
    this.previewFrom.StartDate = "";
    this.previewFrom.EndDate = "";
    this.previewFrom.QCPlanGuid = "";
    this.setFromName();
    this.positionChange();
    this.steptype = 1;
    this.statusBar.forEach((item, index) => {
      item.date = index == 0 ? "1" : null;
    });
    this.getBodyPartDetail(1);

    let _this = this;
    let filteredData = this.detailsRulesParameter.modalityType.filter(function(item) {
      return _this.previewFrom.ModalityTypes.includes(item.Name);
    });
    let uniqueIds = filteredData.map(function(item) {
      return item.UniqueId;
    });
    this.scanTypeByBody.modalityId = uniqueIds.join();
    this.GetBodyPartsByModality({ modalityId: uniqueIds.join() });
    this.GetScanTypeByBodyId({
      modalityId: "",
      bodyPartId: "",
    });
    this.detailsRulesParameter.ScanTypes = [];
  },
  mounted() {
    this.$nextTick(function() {
      this.GetAICompanys();
      this.GetDiseaseTypes();
    });
  },
  updated() {
    let _this = this;
    if (this.steptype == 2 && _this.HospitalsChoice.length > 0) {
      _this.HospitalsChoice.forEach((row) => {
        _this.$refs.selectionTable.toggleRowSelection(row, true);
      });
    }
    if (_this.getDoctorslist.length > 0 && _this.dialogVisible) {
      _this.getDoctorslist.forEach((row) => {
        if (!row.NoteType) {
          _this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      });
    }
  },
  created() {
    // this.GetBodyParts();
    this.GetReportModality();
    // this.GetReportScanType()
    this.tabList = [];
    this.detailsRulesParameter.ScanTypes = [];
  },
  methods: {
    ...Vuex.mapMutations("newtask", ["setRightLoading"]),
    ...Vuex.mapMutations("breadcrumb", ["setTootipType", "clearRow", "breadListMutations"]),
    ...Vuex.mapMutations("managerPlanList", ["setDoctorStatus", "setLoading", "currentChangesSecond"]),
    ...Vuex.mapActions("newtask", [
      "GetAICompanys",
      "GetDiseaseTypes",
      "GetList",
      "GetExpertGroupList",
      "createorupdate",
      "GetBodyParts",
      "GetReportModality",
      "GetReportScanType",
      "GetBodyPartsByModality",
      "GetScanTypeByBodyId",
    ]),
    handleClick(e) {
      let _this = this;
      let extractedChildren = _this.detailsRulesParameter.BodyPart;
      var filteredData = extractedChildren.filter(function(item) {
        return [e.$options.propsData.name].includes(item.Name);
      });
      var uniqueIds = filteredData.map(function(item) {
        return item.Id;
      });
      this.scanTypeByBody.bodyPartId = uniqueIds.join();
      this.GetScanTypeByBodyId(this.scanTypeByBody);
      this.detailsRulesParameter.ScanTypes = [];
    },
    changeNegative(type) {
      if (this.modifyFrom.NegativePercent != 0 || this.modifyFrom.PositivePercent != 0) {
        if (type == "Negative") {
          this.modifyFrom.PositivePercent = 10 - this.modifyFrom.NegativePercent;
        } else {
          this.modifyFrom.NegativePercent = 10 - this.modifyFrom.PositivePercent;
        }
      }
    },
    modifydetermine(type) {
      let name = type == 1 ? "抽样方式" : "报告占比";
      this.$confirm(`确定将此${name}应用到全部中心吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.modifydialog = false;
          if (type == 1) {
            this.modifyFrom.Negative = 0;
            this.modifyFrom.Positive = 0;
          } else {
            this.modifyFrom.Type = 2;
            this.modifyFrom.TypeValue = 0;
          }
          this.getSamplingHospitals();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    modifyList() {
      this.modifydialog = true;
    },
    handleselectAll(rows) {
      rows.forEach((item) => {
        item.SelectedDoctors = item.Doctors;
        item.UnSelectedDoctors = item.NotContainDoctors;
      });
      this.HospitalsChoice = rows;
    },
    getBodyPartDetail(type) {
      let _this = this;
      this.$nextTick(() => {
        _this.activesName = _this.detailsRulesParameter.BodyPart[0].Name;
      });

      // axios.ajaxGet('get', Api.api.manager.GetBodyPartDetail, {
      // 	type: type
      // }).then(res => {
      // 	this.bodyPartDetail = res.data.BodyParts;
      // 	this.activesName = res.data.BodyParts[0].BodyPart;
      // })
    },
    monthChoiceChange(val) {
      this.monthChoice = val;
    },
    closeExperts(parent, childName) {
      this.detailsRulesParameter.BodyParts.forEach((item, index) => {
        // console.log(childName.BodyPartName == item);
        if (childName.Name == item) {
          this.detailsRulesParameter.BodyParts.splice(index, 1);
        }
      });
      this.delOneItem(parent, childName);
    },
    extractChildren(node) {
      let result = [];
      if (node.Children && node.Children.length > 0) {
        for (let child of node.Children) {
          result.push(child);
          result = result.concat(this.extractChildren(child));
        }
      }

      return result;
    },
    checkType(type, item) {
      let _this = this;
      let extractedChildren = [];
      if (type) {
        for (let item of this.detailsRulesParameter.BodyPart) {
          extractedChildren = extractedChildren.concat(this.extractChildren(item));
        }
      } else {
        extractedChildren = _this.detailsRulesParameter.BodyPart;
      }
      var filteredData = extractedChildren.filter(function(item) {
        return _this.detailsRulesParameter.BodyParts.includes(item.Name);
      });
      // 提取 Id 组成的数组
      var uniqueIds = filteredData.map(function(item) {
        return item.Id;
      });
      if (this.position == 0) {
        this.scanTypeByBody.bodyPartId = uniqueIds.join();
        this.GetScanTypeByBodyId(this.scanTypeByBody);
      }
      this.newname = item;
      this.checkboxType = type;
    },
    checkClick(value, parent, index) {
      let _this = this;
      let flag = true;
      let tabIndex = 0;
      if (this.checkboxType) {
        if (_this.tabList.length > 0) {
          for (let i = 0; i < _this.tabList.length; i++) {
            if (_this.tabList[i].BodyPart == parent) {
              flag = true;
              tabIndex = i;
              break;
            } else {
              flag = false;
            }
          }
          if (flag) {
            _this.tabList[tabIndex].ChildrenBodyPart.push(_this.newname);
          } else {
            _this.setOnetab(parent, index);
          }
        } else {
          _this.setOnetab(parent, index);
        }
      } else {
        _this.delOneItem(parent, _this.newname);
      }
    },
    setOnetab(parent, index) {
      this.tabList.push({
        BodyPart: parent,
        sort: index,
        ChildrenBodyPart: [this.newname],
      });
    },
    delOneItem(parent, childName) {
      let _this = this;
      this.tabList.forEach((item, itemindex) => {
        if (item.BodyPart == parent) {
          item.ChildrenBodyPart.forEach((items, itemsindex) => {
            if (items.Name == childName.Name) {
              item.ChildrenBodyPart.splice(itemsindex, 1);
            }
          });
          if (item.ChildrenBodyPart.length <= 0) {
            _this.tabList.splice(itemindex, 1);
          }
        }
      });
    },
    //检查部位切换
    positionChange() {
      this.tabList = [];
      this.detailsRulesParameter.BodyParts = [];
      if (this.position == 1) {
        this.GetScanTypeByBodyId({
          modalityId: this.filterDate().join(","),
          bodyPartId: this.detailsRulesParameter.BodyPart[0].Id,
        });
      }
    },
    // cellClass(row) {
    // 	if (row.columnIndex === 0) {
    // 		return 'disabledCheck'
    // 	}
    // },
    // 预览时候点击的弹窗
    sampledClick(row, type) {
      this.dialogVisible = true;
      this.doctorDiaType = false;
      this.sampledClicktype = type;
      let list = [];
      if (type == 1) {
        list = row.SelectedDoctors;
        this.doctorDiaTitle = "已抽样医生";
      } else {
        list = row.UnSelectedDoctors;
        this.doctorDiaTitle = "未抽样医生";
      }
      this.getDoctorslist = list;
    },
    // 抽样方式失去焦点
    getSampledNum(row,type) {
      let _this = this;
      if (row.Type != 0) {
        let SampledCount = 0;
        this.dialogLoading = true;
        this.selfLoading = true;
        this.sampleReportForm.Type = row.Type;
        this.sampleReportForm.TypeValue = row.TypeValue;
        this.sampleReportForm.HospitalGuid = row.HospitalGuid;
        // this.sampleReportForm.Doctors = type == 'distributionDoctor' ? row.SelectedDoctors : null;
        this.sampleReportForm.Doctors =  row.SelectedDoctors
        this.sampleReportForm.NegativePercent = row.Negative;
        this.sampleReportForm.PositivePercent = row.Positive;
        this.sampleReportForm.DoctorCheck = _this.settings.includes("DoctorCheck");
        if (row.Negative != 0 || row.Positive != 0) {
          if (arguments[1] == "Negative") {
            this.sampleReportForm.NegativePercent = row.Negative;
            this.sampleReportForm.PositivePercent = 10 - row.Negative;
            row.Positive = this.sampleReportForm.PositivePercent;
          } else if (arguments[1] == "Positive") {
            this.sampleReportForm.PositivePercent = row.Positive;
            this.sampleReportForm.NegativePercent = 10 - row.Positive;
            row.Negative = this.sampleReportForm.NegativePercent;
          }
        }
        //获取医生列表
        axios.ajaxPost("post", Api.api.manager.GetOneHospitalSampledNum, this.sampleReportForm).then((res) => {
          if (res.data.StatusCode == 200) {
            if(type !== 'distributionDoctor'){
              // 如果不是弹窗勾选则重置已选医生列表
              row.UnSelectedDoctors = res.data.NotContainDoctors;// 待确认取啥呢
              this.getDoctorslist = res.data.Doctors.map((item) => {
                item.NoteType = false;
                item.Note = "";
                SampledCount += Number(item.SampledNum);
                return item;
              });
              row.SelectedDoctors = this.getDoctorslist;
              row.doctorList = [];
            }
            row.PositiveCount = res.data.PositiveCount;
            row.NegtativeCount = res.data.NegtativeCount;
            // row.SamplingCount = SampledCount;
            row.SamplingCount = res.data.SampledCount;
            // 已选，未选
            row.sampled = res.data.SelectedDoctorCount;//已选
            row.notSampled = res.data.UnselectedDoctorCount;//未选
            row.SampledDoctorCount = res.data.SampledDoctorCount;//可选
            row.NotSampledDCount = res.data.NotSampledDCount;//不可选
            row.Doctors = res.data.Doctors;// 不可选医生列表
            row.NotContainDoctors = res.data.NotContainDoctors;// 不可选医生列表

          }
          this.dialogLoading = false;
          this.selfLoading = false;
        });
      }
    },
    // 弹窗表格的操作
    distributionDoctor() {
      let flag = true;
      let NoteList = [];
      NoteList = this.getDoctorslist.filter((item) => {
        if (item.NoteType) {
          return item;
        }
      });
      if (NoteList.length > 0) {
        for (let i = 0; i < NoteList.length; i++) {
          if (NoteList[i].Note == "") {
            flag = false;
            this.$message({
              message: "请填写备注",
            });
            return false;
          } else {
            flag = true;
          }
        }
      }
      if (flag) {
        this.Hospitals[this.dialogIndex].doctorList = this.getDoctorslist;
        this.Hospitals[this.dialogIndex].SelectedDoctors = this.dialogChoice;
        this.Hospitals[this.dialogIndex].sampled = this.getDoctorslist.length - NoteList.length;
        this.Hospitals[this.dialogIndex].UnSelectedDoctors =
          this.Hospitals[this.dialogIndex].NotContainDoctors == null
            ? []
            : this.Hospitals[this.dialogIndex].NotContainDoctors.concat(NoteList);

        console.log(this.Hospitals[this.dialogIndex],'aaaaaaaaaaaaaaaaaaaaa')
        console.log(NoteList,'bbbbbbbbbbbbbbbb')
        console.log(this.Hospitals[this.dialogIndex].NotContainDoctors,'cccccccccc')
        this.Hospitals[this.dialogIndex].notSampled = this.Hospitals[this.dialogIndex].UnSelectedDoctors.length;
        this.getSampledNum(this.Hospitals[this.dialogIndex],'distributionDoctor');
        this.dialogVisible = false;
      }
    },
    selectAll(row) {
      this.getDoctorslist.forEach((item) => {
        if (row.length <= 0) {
          item.NoteType = true;
        } else {
          item.NoteType = false;
        }
      });
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectClick(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      row.NoteType = !selected && selected == 0 ? true : false;
    },
    // 弹出框勾选事件
    dialogChange(row) {
      this.dialogChoice = row;
    },
    notSampledClick(row, index) {
      let _this = this;
      this.doctorDiaTitle = "不符合抽样医生";
      this.dialogVisible = true;
      this.doctorDiaType = false;
      this.getDoctorslist = row.NotContainDoctors;
      this.dialogIndex = index;
      this.HospitalName = row.HospitalName;
      this.sampleReportForm.HospitalGuid = row.HospitalGuid;
      this.sampleReportForm.Type = row.Type;
      this.sampleReportForm.TypeValue = row.TypeValue;
      this.sampleReportForm.Doctors = [];
      this.sampleReportForm.NegativePercent = row.Negative;
      this.sampleReportForm.PositivePercent = row.Positive;
      //获取医生列表
      axios.ajaxPost("post", Api.api.manager.GetSamplingDoctors, this.sampleReportForm).then((res) => {
        _this.getDoctorslist = res.data.Doctors.map((item) => {
          item.NoteType = false;
          item.Note = "";
          return item;
        });
        this.dialogLoading = false;
      });
    },
    // 医生列表
    choiceClick(row, index) {
      let _this = this,
        list = [];
      this.dialogVisible = true;
      this.doctorDiaType = arguments[2] ? false : true;
      this.dialogLoading = true;
      this.doctorDiaTitle = arguments[2] ? "不可选医生" : "可选医生";
      this.dialogIndex = index;
      this.HospitalName = row.HospitalName;
      this.sampleReportForm.HospitalGuid = row.HospitalGuid;
      this.sampleReportForm.Type = row.Type;
      this.sampleReportForm.TypeValue = row.TypeValue;
      this.sampleReportForm.Doctors = [];
      this.sampleReportForm.NegativePercent = row.Negative;
      this.sampleReportForm.PositivePercent = row.Positive;
      if (row.doctorList.length <= 0) {
        //获取医生列表
        axios.ajaxPost("post", Api.api.manager.GetSamplingDoctors, this.sampleReportForm).then((res) => {
          list = arguments[2] ? res.data.NotContainDoctors : res.data.Doctors;
          _this.getDoctorslist = list.map((item) => {
            item.NoteType = false;
            item.Note = "";
            return item;
          });
          this.dialogLoading = false;
        }).catch((err) => {
          this.dialogLoading = false;
        });
      } else {
        if (row.Type == 0) {
          // 如果抽样类型为0，
          _this.getDoctorslist = row.doctorList;
        } else {
          let changeTypeList = [];
          axios.ajaxPost("post", Api.api.manager.GetSamplingDoctors, this.sampleReportForm).then((res) => {
            list = arguments[2] ? res.data.NotContainDoctors : res.data.Doctors;
            for (let i = 0; i < row.doctorList.length; i++) {
              row.doctorList[i].SampledNum = list[i].SampledNum;
            }
            _this.getDoctorslist = row.doctorList;
            console.log(_this.getDoctorslist,'ccccccccccccccc')
            this.dialogLoading = false;
          }).catch((err) => {
            this.dialogLoading = false;
          });
        }
      }
    },
    // 获取医院列表数据
    getSamplingHospitals() {
      let _this = this;
      _this.selfLoading = true;
      let StartDt = "";
      let EndDt = "";
      if (this.monthChoice == 0) {
        StartDt = this.previewFrom.StartDate;
        EndDt = this.previewFrom.StartDate;
      } else {
        StartDt = this.previewFrom.StartDate;
        EndDt = this.previewFrom.EndDate;
      }
      this.sampleReportForm = {
        ModalityTypes: this.previewFrom.ModalityTypes.join(","),
        ScanTypes: this.detailsRulesParameter.ScanTypes.join(","),
        StartDt: StartDt,
        EndDt: EndDt,
        Postive: this.detailsRulesParameter.IsPositives.join(","),
        BodyParts: this.detailsRulesParameter.BodyParts.join(","),
        HospitalLevel: this.previewFrom.hospitalGrade,
        Name: this.previewFrom.Name,
        Category: this.previewFrom.Category,
        QCPlanGuid: this.previewFrom.QCPlanGuid,
        PlannedCompleteDt: this.previewFrom.PlannedCompleteDt,
        QCTimes: this.previewFrom.QCTimes,
        Type: this.modifyFrom.Type,
        TypeValue: this.modifyFrom.TypeValue,
        NegativePercent: this.modifyFrom.NegativePercent,
        PositivePercent: this.modifyFrom.PositivePercent,
        HospitalGuid: "",
        Doctors: [],
        CheckingItems: this.detailsRulesParameter.BodyParts.join(","),
        SubjectType: this.previewFrom.samplingdoctor,
        WyxCheck: this.settings.includes("WyxCheck"),
        DoctorCheck: this.settings.includes("DoctorCheck"),
      };
      this.sampleReportForm.CheckingItems = this.position == "0" ? "" : this.detailsRulesParameter.BodyParts.join(",");
      this.sampleReportForm.BodyParts = this.position == "0" ? this.detailsRulesParameter.BodyParts.join(",") : "";
      axios.ajaxPost("post", Api.api.manager.GetSamplingHospitals, this.sampleReportForm).then((res) => {
        _this.Hospitals = res.data.Hospitals.map((item) => {
          item.sampled = item.SampledDoctorCount;
          item.notSampled = item.NotSampledDCount;
          item.doctorList = [];
          item.SelectedDoctors = item.Doctors || [];
          item.UnSelectedDoctors = [];
          return item;
        });
        _this.NotContailHospitals = res.data.NotContailHospitals.map((item) => {
          item.doctorList = [];
          return item;
        });
        _this.selfLoading = false;
      });
    },
    // 下一步
    next(type) {
      if (type == 1) {
        if (this.monthChoice == 1) {
          let overdate = date.getDaysBetween(this.previewFrom.StartDate, this.previewFrom.EndDate);
          if (overdate > 60) {
            this.$message({
              message: "您选择的抽样时间过长，可能会导致加载失败，建议抽样时间不超过60天。",
            });
          }
        }
        this.$refs.newtaskPageFrom.validate((valid) => {
          console.log(valid);
          if (valid) {
            this.statusBar[type].date = "1";
            this.steptype = 2;
            // CheckingItems
            this.getSamplingHospitals();
          } else {
            return false;
          }
        });
      }
      if (type == 2) {
        let flag = true;
        let hospitalsChoice = this.HospitalsChoice;
        if (hospitalsChoice <= 0) {
          this.$message({
            message: "请选择抽样机构",
          });
          flag = false;
        } else {
          for (let i = 0; i < hospitalsChoice.length; i++) {
            hospitalsChoice[i].Doctors.forEach((item) => {
              item.TypeValue = hospitalsChoice[i].TypeValue;
            });
            if (
              hospitalsChoice[i].Type == 0 ||
              hospitalsChoice[i].TypeValue == 0 ||
              hospitalsChoice[i].SamplingCount == 0
            ) {
              this.$message({
                message: "请填写完整的抽样方式，包括选择抽样类型及填写数量",
              });
              flag = false;
              return false;
            } else {
              flag = true;
            }
          }
        }
        if (flag) {
          this.$confirm("确认以上抽样方式吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {
              this.steptype = 3;
              this.statusBar[type].date = "1";
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        }
      }
    },
    toback(type) {
      this.steptype = type;
      this.statusBar[type].date = null;
    },
    setFromName() {
      if (this.previewFrom.Category == "" || this.previewFrom.Category == 1) {
        this.previewFrom.CategoryName = "影像";
      } else if (this.previewFrom.Category == 2) {
        this.previewFrom.CategoryName = "报告";
      } else {
        this.previewFrom.CategoryName = "影像和报告";
      }
      let date = new Date(); //日期对象
      this.previewFrom.Name =
        date.getFullYear() +
        "" +
        (date.getMonth() + 1) +
        "" +
        date.getDate() +
        "" +
        date.getHours() +
        "" +
        date.getMinutes() +
        "-" +
        this.previewFrom.CategoryName;
    },
    handleSelectionClick(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (selected && selected != 0) {
        this.getSampledNum(row);
      }
    },
    handleSelectionChange(row) {
      this.HospitalsChoice = row;
    },
    filterDate() {
      let _this = this;
      // 使用 filter 方法过滤数组
      let filteredData = this.detailsRulesParameter.modalityType.filter(function(item) {
        return _this.previewFrom.ModalityTypes.includes(item.Name);
      });
      // 提取 UniqueId 组成的数组
      let uniqueIds = filteredData.map(function(item) {
        return item.UniqueId;
      });
      return uniqueIds;
    },
    //抽样类型设备筛选
    getExportImg() {
      let _this = this;
      if (this.previewFrom.Category == "") {
        _this.$message({
          message: "请先选择抽样类型！",
        });
        _this.previewFrom.ModalityTypes = [];
        return false;
      }

      let date = new Date(), //日期对象
        ModalityTypes = this.previewFrom.ModalityTypes;
      if (this.previewFrom.Name.indexOf(date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate()) != -1) {
        this.setFromName();
      }
      // // 使用 filter 方法过滤数组
      // let filteredData = this.detailsRulesParameter.modalityType.filter(function(item) {
      // 	return _this.previewFrom.ModalityTypes.includes(item.Name);
      // });
      // // 提取 UniqueId 组成的数组
      // let uniqueIds = filteredData.map(function(item) {
      // 	return item.UniqueId;
      // });
      let uniqueIds = this.filterDate();
      if (uniqueIds.length > 0) {
        this.setRightLoading(true);
        this.GetBodyPartsByModality({ modalityId: uniqueIds.join() });
        this.scanTypeByBody.modalityId = uniqueIds.join();
        // console.log(this.scanTypeByBody);
        this.GetScanTypeByBodyId(this.scanTypeByBody);
      }
      //清空方案
      this.previewFrom.QCPlanGuid = "";
      this.previewFrom.QCPlanName = "";
      //清空检查部位和扫描类型
      this.detailsRulesParameter.BodyParts = [];
      this.tabList = [];
      this.detailsRulesParameter.ScanTypes = [];
      this.position = "0";

      this.GetList();
      this.GetExpertGroupList();
      this.arrFilters();
      if (ModalityTypes.indexOf("CT") > -1 || ModalityTypes.indexOf("MR") > -1 || ModalityTypes.indexOf("DR") > -1) {
        this.getBodyPartDetail(1);
        this.previewFrom.samplingdoctor = 2;
      }
      if (ModalityTypes.indexOf("US") > -1) {
        this.getBodyPartDetail(2);
        ModalityTypes = ["US"];
        this.usHidden = false;
        this.isUS = true;
        this.$message({
          message: "超声不能与其他设备同时选择,如需选择其他设备请取消超声后选择",
        });
        this.previewFrom.samplingdoctor = 4;
        return false;
      } else {
        this.isUS = false;
        this.usHidden = true;
      }
      if (this.previewFrom.Category == 1) {
        this.previewFrom.samplingdoctor = 3;
      } else {
        this.previewFrom.samplingdoctor = 2;
      }
      console.log(this.previewFrom.samplingdoctor);
    },
    //提交
    onSubmit() {
      let _this = this;
      let subCreateSampling = {};
      Object.assign(subCreateSampling, this.sampleReportForm);
      subCreateSampling.Hospitals = this.HospitalsChoice;
      subCreateSampling.Doctors = [];
      subCreateSampling.HospitalGuid = "";
      subCreateSampling.Creator = "";
      subCreateSampling.CreatorName = "";
      subCreateSampling.Type = 0;
      subCreateSampling.TypeValue = 0;
      this.$confirm("确认创建此条抽样任务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          _this.setLoading(true);
          axios.ajaxPost("post", Api.api.manager.CreateSampling, subCreateSampling).then((res) => {
            if (res.data.StatusCode == 200) {
              _this.goTasksecondaryTable(res.data.SamplingTask);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消创建，您可修改后继续创建",
          });
        });
    },
    goTasksecondaryTable(row) {
      //clear
      this.setTootipType(false);
      this.clearRow();
      this.reviewName.name = "";
      this.currentChangesSecond(1);
      this.collapseflag.flag = false;
      this.SamplingTaskGuId.SamplingTaskGuid = row.SamplingTaskGuid;
      this.SamplingTaskGuId.ExpertUserGuid = "";
      this.taskListTitle.Id = row.Id;
      this.taskListTitle.name = row.Name;
      this.taskListTitle.categoryName = row.CategoryName;
      this.setDoctorStatus(this.statusList);

      this.breadListState[1].name = "任务详情";
      this.breadListState[1].path = "/home/manager/task/tasksecondaryTable";
      this.$router.push("/home/manager/task/tasksecondaryTable");
    },
    // table中单选改变
    radioFilters(row, type, index) {
      row.type = type;
      this.getSampledNum(row);
      this.$set(this.Hospitals, index, row);
    },

    arrFilters() {
      //抽样类型
      if (this.previewFrom.Category != "") {
        this.previewFromRigth.Category = this.detailsRulesParameter.types.filter((res) => {
          if (res.Value == this.previewFrom.Category) {
            return res.Text;
          }
        });
      }
      if (this.detailsRulesParameter.IsPositives) {
        this.previewFromRigth.IsPositive = this.detailsRulesParameter.IsPositive.filter((res) => {
          for (let i = 0; i < this.detailsRulesParameter.IsPositives.length; i++) {
            if (res.value == this.detailsRulesParameter.IsPositives[i]) {
              return res;
            }
          }
        });
      }
      if (this.previewFrom.ExpertGroupIDList.length > 0) {
        this.previewFromRigth.ExpertGroupIDList = this.ExpertGroupList.filter((res) => {
          for (let i = 0; i < this.previewFrom.ExpertGroupIDList.length; i++) {
            if (res.ExpertGroupGuid == this.previewFrom.ExpertGroupIDList[i]) {
              return res;
            }
          }
        });
      }
      if (this.previewFrom.QCPlanGuid != "") {
        this.previewFromRigth.QCPlanGuid = this.listReport.filter((res) => {
          if (res.QCPlanGuid == this.previewFrom.QCPlanGuid) {
            this.previewFrom.QCPlanName = res.Name;
            return res;
          }
        });
      }
    },
    closeSplitScreen() {
      this.$router.go(-1);
    },
  },
};
</script>
<style>
/* 去掉全选按钮 */
.el-table .disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}

.el-table .disabledCheck .cell::before {
  content: "选择";
  text-align: center;
  line-height: 37px;
}
.paddingL .el-tabs__nav-next,
.paddingL .el-tabs__nav-prev {
  line-height: 24px !important;
}
.paddingL .el-tabs__content {
  padding-left: 41px;
}
</style>
<style lang="scss">
.scanTypesClass .el-select__tags .el-tag {
  background-color: #282b32 !important;
}
</style>
<style lang="scss" scoped="scoped">
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";

.ratioInput {
  background-color: #494d57 !important;
}

.wid50 {
  width: 50px !important;
}

.newtaskPage .el-row {
  line-height: 32px !important;
}

.paddingL {
  padding-left: 16px;
}

.setUpcol {
  padding-left: 20px;
  box-sizing: border-box;
}

.qcTable .el-radio {
  margin-right: 10px !important;
}

.footerBtn {
  margin-top: 15px;
}

.el-button {
  border: 1px solid #248afd;
}

.el-dialog .el-button {
  border-color: transparent;
}

.editFroms .dialogInput {
  @include bg-color(totalColor);
  width: 100% !important;
}

.dialogTitle {
  font-size: 12px;
  @include text-color(fzColor);
  margin-bottom: 14px;
}

.newtaskPage .previewTitle {
  margin-bottom: 20px;
  font-size: 16px;
}

.grid-content {
  padding: 4px 0 4px 42px;
  line-height: 22px;
}

.editFroms .el-table__footer-wrapper {
  border-radius: 0 0 6px 6px;
}
.el-input--prefix .el-input__inner {
  padding-left: 25px !important;
}

.el-tabs--card >>> .el-tabs__nav-wrap.is-scrollable {
  @include bg-color(closebg);
  border-radius: 6px 6px 0 0;
}

.el-tabs--card >>> .el-tabs__nav-prev {
  left: 4px;
  line-height: 35px;
}

.el-tabs--card >>> .el-tabs__nav-next {
  right: 4px;
  line-height: 35px;
}

.el-tabs--card >>> .el-tabs__header .el-tabs__item {
  border-right: none;
  height: 35px;
  line-height: 35px;
  @include bg-color(closebg);
}

.el-tabs--card >>> .el-tabs__header .el-tabs__item:first-child {
  border-top-left-radius: 6px;
}

.el-tabs--card >>> .el-tabs__header .el-tabs__item:last-child {
  border-top-right-radius: 6px;
}

.el-tabs--card >>> .el-tabs__header .el-tabs__item.is-active {
  color: #ffffff;
  background-color: #248afd;
  border-radius: 6px 6px 0 0;
}

.el-tabs--card >>> .el-tabs__header {
  margin-bottom: 0;
}

.paddingL .el-tabs--card >>> .el-tabs__content {
  display: block !important;
  padding: 15px 20px 0 20px;
  box-sizing: border-box;
  @include bg-color(isreadBg);
}

.paddingL .el-tabs--card >>> .el-checkbox__label {
  margin-bottom: 15px;
}
.el-tag.el-tag--info {
  @include bg-color(closebg);
  // background-color: #282b32 !important;
}
.setUp >>> .el-collapse {
  margin-bottom: 25px;
}

.setUp >>> .el-collapse-item__header {
  padding-left: 0;
  justify-content: flex-end;
  @include bg-color(closebg);
  border-radius: 6px;
  margin-bottom: 0;
}

.setUp >>> .el-collapse-item__arrow {
  left: auto;
  line-height: 18px;
}

.setUp >>> .el-collapse-item__arrow:before {
  content: "\e790" !important;
}

.setUp >>> .el-collapse-item__content {
  padding-bottom: 0;
  @include bg-color(isreadBg);
  border-radius: 0 0 6px 6px;
}

.setUp >>> .selectedList {
  @include bg-color(isreadBg);
  padding: 20px 20px 20px 0;
  box-sizing: border-box;
  border-radius: 6px;
  @include text-color(menuColor);
  margin-bottom: 28px;
}

.setUp >>> .grid-content {
  padding-left: 20px;
}

.titleSelected {
  padding-right: 35px;
  color: #248afd;
}

.toBack {
  @include bg-color(titleBg);
  @include text-color(btnColor);
}
</style>
